import { CamelCaseFormatter } from './index'
import i18n from '@i18n'

export function t(key, componentName, ...params) {
    const camelizedKey = CamelCaseFormatter(key, '_')
    const tranKey = componentName + '.' + camelizedKey

    return i18n.exists(tranKey) ? i18n.t(tranKey, ...params) : i18n.t('common:' + camelizedKey, ...params)
}

export function getCurrentLang() {
    return i18n.language
}

export function getCodeMsg(code, options) {
    return i18n.t('code:' + code, options)
}

export function getGameText(key, componentName, options) {
    const tranKey = componentName + '.' + key
    return i18n.t('game:' + tranKey, options)
}

export function getGameName(gameCode) {
    return i18n.t(`common:GameName.${gameCode}`)
}
